import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const ContactShowComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const contactId = props.contactId || window.App.urlVars().contactId || id;

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if (contactId) {
      setLoading(true);

      apiCall('get', '/api/v2/contact/' + contactId)
        .then(response => {
          const data = response.data.data || {};
          setFormData(data);
          if (typeof props.onLoaded === 'function') {
            props.onLoaded(data);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [contactId, window.App.state.rerenderContactList])

  return (
    <div className={"contact-show widget"}>
      {loading &&
        <ProgressBar
          mode="indeterminate"
          style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0}}
        />
      }

      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName2')}</label>
            <span className="p-d-block fake-input">
              {formData?.name ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="phone">{t('columnPhoneNumber')}</label>
            <span className="p-d-block fake-input">
              {formData?.phone ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="email">{t('columnEmail')}</label>
            <span className="p-d-block fake-input">
              {formData?.email ?? ''}
            </span>
          </div>
        </div>

        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="note">{t('columnComment')}</label>
            <span className="p-d-block fake-input">
              {formData?.note ?? ''}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(ContactShowComponent);